import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';

@Injectable()
export class ServicesService {
  public contas: Array<any>;

  constructor(public httpService: HttpService) { }

  public buscaCEP(cep) {
    return this.httpService.get(this.httpService.pathRest().get + 'endereco/' + cep + '/');
  }

  public moedaToPontos(valor, indice) {
    valor = parseFloat(valor);
    indice = parseFloat(indice);
    if (typeof valor === 'number' && typeof indice === 'number') {
      return valor && indice ? (Math.ceil(valor / indice)) : 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/services.service.ts